/* ============================================
   PAWPY — Interactions
   ============================================ */

(() => {
  // -- Nav scroll effect
  const nav = document.querySelector('.nav');
  if (nav) {
    const onScroll = () => {
      nav.classList.toggle('scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // -- Mobile nav toggle
  const toggle = document.querySelector('.nav-toggle');
  const navLinks = document.querySelector('.nav-links');
  if (toggle && navLinks) {
    toggle.addEventListener('click', () => navLinks.classList.toggle('open'));
  }

  // -- Fade-up on scroll
  const fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window && fadeEls.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    fadeEls.forEach((el) => io.observe(el));
  } else {
    fadeEls.forEach((el) => el.classList.add('in'));
  }

  // -- FAQ accordion
  document.querySelectorAll('.faq-item').forEach((item) => {
    const btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach((o) => o.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  // -- Product option pills + prix dynamique
  const BASE_PRICE = 34.95; // Prix d'1 boîte de 30 sachets

  const fmtPrice = (n) => n.toFixed(2).replace('.', ',') + '€';

  function updatePrice() {
    const formatPill = document.querySelector('.option-pills[data-group="format"] .option-pill.selected');
    const freqPill = document.querySelector('.option-pills[data-group="frequency"] .option-pill.selected');
    if (!formatPill || !freqPill) return;

    const months = parseInt(formatPill.dataset.months || '1', 10);
    const sachets = parseInt(formatPill.dataset.sachets || '30', 10);
    const isSubscription = freqPill.dataset.frequency === 'subscription';

    let discount = 0;
    if (months === 3) discount += 0.10;
    if (isSubscription) discount += 0.20;

    const subtotal = BASE_PRICE * months;
    const finalPrice = subtotal * (1 - discount);
    const perDay = finalPrice / sachets;

    const priceCurrent = document.getElementById('price-current');
    const priceOld = document.getElementById('price-old');
    const priceUnit = document.getElementById('price-unit');
    const ctaPrice = document.getElementById('cta-price');

    if (priceCurrent) priceCurrent.textContent = fmtPrice(finalPrice);
    if (ctaPrice) ctaPrice.textContent = fmtPrice(finalPrice);
    if (priceOld) priceOld.textContent = discount > 0 ? fmtPrice(subtotal) : '';
    if (priceUnit) {
      const label = sachets === 30 ? 'la boîte de 30 sachets' : 'les 3 boîtes (90 sachets)';
      const dayPrice = perDay.toFixed(2).replace('.', ',');
      priceUnit.textContent = `${label} · ${dayPrice}€/jour`;
    }
  }

  document.querySelectorAll('.option-pills').forEach((group) => {
    group.querySelectorAll('.option-pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        group.querySelectorAll('.option-pill').forEach((p) => p.classList.remove('selected'));
        pill.classList.add('selected');
        updatePrice();
      });
    });
  });

  // Initialiser au chargement
  updatePrice();

  // -- Reveal toggle (composition page produit)
  document.querySelectorAll('.reveal-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetId = btn.dataset.target;
      const target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;
      const isOpen = target.classList.toggle('open');
      btn.classList.toggle('open', isOpen);
      btn.setAttribute('aria-expanded', String(isOpen));
      btn.querySelector('span:first-child').textContent = isOpen ? 'Masquer les actifs' : 'Voir les actifs';
    });
  });

  // -- Full ingredient list toggle
  document.querySelectorAll('.full-list').forEach((wrap) => {
    const btn = wrap.querySelector('.full-list-toggle');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const isOpen = wrap.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });

  // -- Product thumbnails
  document.querySelectorAll('.product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.product-main-img img');
      const img = thumb.querySelector('img');
      if (main && img) {
        main.src = img.src;
        document.querySelectorAll('.product-thumb').forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  // -- Smooth anchor offset already handled by scroll-behavior

  // -- Contact form (faux submit)
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = contactForm.querySelector('button[type="submit"]');
      const originalText = btn.innerHTML;
      btn.innerHTML = 'Merci ✓';
      btn.disabled = true;
      setTimeout(() => {
        contactForm.reset();
        btn.innerHTML = originalText;
        btn.disabled = false;
      }, 2400);
    });
  }
})();
